import React, { memo } from 'react';
import MatchBoxScoreView from '../MatchBoxScoreView';
import { MatchAdmin } from '../../../models/interfaces/Match';
import { SportProvider } from '../../../models/interfaces/SportProvider';
import { MatchSegmentStats } from '../../../models/interfaces/Stat';
import { Row, Col } from 'react-bootstrap';
import MatchPlayerSummary from '../MatchPlayerSummary';
import TeamMatchSummaryView from '../TeamMatchSummary';

interface Props {
    matchAdmin: MatchAdmin;
    matchStatsList: MatchSegmentStats[];
    sportProvider: SportProvider;
}

// matchStatsList & sportProvider have been prop drilled to get to this stage
const RefSummaryView = memo(({ matchAdmin, matchStatsList, sportProvider }: Props) => {
    const { match } = matchAdmin;
    const teamSummaries = matchAdmin.match.officialViewConfiguration
        .teamSummaries(matchStatsList)
        .map((teamSummary) => {
            return {
                title: teamSummary.title,
                lightCapTextComponents: teamSummary.displayTextForStats(teamSummary.lightCapStats, teamSummary.darkCapStats),
                darkCapTextComponents: teamSummary.displayTextForStats(teamSummary.darkCapStats, teamSummary.lightCapStats),
            };
        });

    const playerSummaries = matchAdmin.match.officialViewConfiguration
        .playerSummaries(matchStatsList)
        .map((playerSummary) => {
            return {
                title: playerSummary.title,
                lightCapPlayers: playerSummary.lightCapPlayerArray.map((lightCapPlayerItem) => {
                    return {
                        player: lightCapPlayerItem.player,
                        textComponents: playerSummary.displayTextForStats(lightCapPlayerItem.stats),
                    };
                }),
                darkCapPlayers: playerSummary.darkCapPlayerArray.map((darkCapPlayerItem) => {
                    return {
                        player: darkCapPlayerItem.player,
                        textComponents: playerSummary.displayTextForStats(darkCapPlayerItem.stats),
                    };
                }),
            };
        });

    return (
        <div className="RefSummaryView py-2">
            <Row>
                <Col>
                    <MatchBoxScoreView
                        match={match}
                        matchStatsList={matchStatsList}
                        sportProvider={sportProvider}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <TeamMatchSummaryView
                        match={matchAdmin.match}
                        summaries={teamSummaries}
                        compact={true}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <MatchPlayerSummary
                        match={matchAdmin.match}
                        playerSummaries={playerSummaries}
                        allowsLinkToPlayerProfile={false}
                        compact={true}
                    />
                </Col>
            </Row>
        </div>
    );
});

export default RefSummaryView;
